export default "<p>general-add works!</p>\n"